import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StyledTextDescribeModal, StyledTitleModal } from "./ConfirmPublishAds.modal";

const EditedAdModal = () => {
  const { t } = useTranslation();

  return (
    <Stack alignItems="center" justifyContent="center" paddingY="1.5rem" spacing={2}>
      <img src="/images/illus_check.svg" alt="check" style={{ width: "48px", height: "48px" }} />

      <StyledTitleModal>{t("ads.details.modals.publish.confirm.editedAdTitle")}</StyledTitleModal>

      <StyledTextDescribeModal sx={{ paddingX: "1rem" }}>{t("ads.details.modals.publish.confirm.editedAd")}</StyledTextDescribeModal>
    </Stack>
  );
};

export default EditedAdModal;
